module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e17c3cb0a043f1b81f933deb1ca3da28.png";